import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import {
  GridContainer,
  GridRow,
  GridColumn,
  Img,
  Utils,
} from "arv-reactcomponents";

import { LoginActionButton } from "../ActionButtons";

import { getLogoURLFromNav } from "../../../utils";

import { Endpoints } from "npmlinks-constants";

import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";

@inject("NavListStore")
@observer
class StaticHeader extends Component {
  static onLogoClick() {
    Analytics.trackEvent({
      action: Event.action.LOGO_CLICK,
      label: Event.label.getSource(window.pageType),
      category: Event.category.TOP_MENU_NAVIGATION,
    });
  }

  get logoImg() {
    const { navListData } = this.props.NavListStore;
    const logoUrl = getLogoURLFromNav(navListData);
    const alt = "NNNOW image";
    // const logoFromApi =
    //   (navListData &&
    //     navListData.data &&
    //     navListData.data.logos &&
    //     navListData.data.logos.brand &&
    //     navListData.data.logos.brand.image) ||
    //   null;
    // const logoUrl = logoFromApi || Endpoints.nnnowLogoUrl;

    if (logoUrl) {
      return (
        <Img className="nw-mainbar-logo is-fixed" src={logoUrl} alt={alt} />
      );
    }
    return null;
  }

  render() {
    return (
      <header className="nw-header nw-staticheader is-fixed">
        <GridContainer className="nw-mainbar-container is-fixed">
          <GridRow className="nw-staticheader-row">
            <GridColumn className="nw-staticheader-col">
              <div className="nw-staticheader-logo-holder">
                <a
                  href="/"
                  target="_self"
                  className="nw-mainbar-logo-link"
                  onClick={StaticHeader.onLogoClick}
                >
                  {this.logoImg}
                </a>
              </div>
              <LoginActionButton.component
                className="nw-mainbar-actionbutton nw-mainbar-actionbutton-login is-fixed"
                text="LOGIN"
              />
            </GridColumn>
          </GridRow>
        </GridContainer>
      </header>
    );
  }
}

StaticHeader.wrappedComponent.propTypes = {
  NavListStore: PropTypes.shape({}).isRequired,
};

const getFinalComponent = component =>
  inject("NavListStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: StaticHeader.wrappedComponent,
  component: StaticHeader,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Header/StaticHeader/index.js